export const getProductTypeLabel = (productType: string | undefined): string | undefined => {
  if (!productType) return undefined

  if (productType === "thermostat") {
    return "Nuve Thermostats"
  }

  return "C Wire Adapters (CWA)"
}
